const baseUrls = {
    production:"https://api.spindlplatform.com/",
    staging:"https://stage-api.spindlplatform.com/",
    development:"http://localhost:8888/"
}
class SpindlApi {
    constructor(env){
        this.baseUrl = baseUrls[env]
        this.authToken = ""
    }
    generateRequestId = ()=>{
        //TODO: implement UUID generate
        return "aaaaaaaaaaa";
    }
    setAuthToken = (token) => {
        this.authToken = token;
    }
    unsetAuthToken = () => {
        this.authToken = "";
    }

    makeRequest = async ({ url, method, data = {} })=>{
        try{
            const options = { 
                method: method,
                mode: "cors", 
                headers:{
                    "Content-Type":"application/json",
                    "Authorization":"Bearer "+ this.authToken
                },
                body: JSON.stringify( {data: data} )                                        
            }
            if(options.method === "GET"){
                delete options.body
            }
            const response = await fetch(url, options)
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const json = await response.json();
            return json;
        }catch(e){
            console.log(e)
            throw e;
            
        }
    }

    //SignIn
    signIn = async ({data})=>{
        const path = `identity/user/signin/`;
        const response = await this.makeRequest({
            url: `${this.baseUrl}${path}`,
            method: "POST",
            data:data
        })
        return response;
    }

    //RateCards
    readRateCards = async()=>{
        const path = `quote/rate_cards/`;
        return await this.makeRequest({
            url: `${this.baseUrl}${path}`,
            method: "GET", 
        })
    }

    //Rate Methods
    updateRate = async ({rateId, data})=>{
        const path = `quote/rates/${rateId}/`;
        const response = await this.makeRequest({
            url: `${this.baseUrl}${path}`,
            method: "PATCH",
            data:data
        })
        return response;  
    }

    createRate = async ({data})=>{
        const path = `quote/rates/`;
        const response = await this.makeRequest({
            url: `${this.baseUrl}${path}`,
            method: "POST",
            data:data
        })
        return response;  
    }
    deleteRate = async ({rateId})=>{
        const path = `quote/rates/${rateId}/`;
        const response = await this.makeRequest({
            url: `${this.baseUrl}${path}`,
            method: "DELETE"
        })
        return response;
    }

    //Rate Card Methods
    readRateCardRates = async ({rateCardId}) =>{
        const path = `quote/rate_cards/${rateCardId}/rates/`;
        const response = await this.makeRequest({
            url: `${this.baseUrl}${path}`,
            method: "GET"
        })
        return response;
    }
    updateRateCard = async ({rateCardId, data})=>{
        const path = `quote/rate_cards/${rateCardId}/`;
        const response = await this.makeRequest({
            url: `${this.baseUrl}${path}`,
            method: "PATCH",
            data:data
        })
        return response; 
    }
}

export default new SpindlApi(process.env.REACT_APP_BUILD_TARGET);



// WEBPACK FOOTER //
// ./src/modules/spindl-api/SpindlApi.js